import React from "react";
import { FaMusic } from "react-icons/fa";
import "../../styles/Home.css";

export default function UserCardHeader({ user, platform, avatarUrl, avatarAlt, icon: Icon }) {
  const renderAvatar = () => {
    if (avatarUrl) {
      return (
        <img
          src={avatarUrl}
          alt={avatarAlt}
          className={`user-avatar ${platform.toLowerCase()}`}
          loading="lazy"
        />
      );
    }

    // Avatar par défaut pour Spotify
    if (platform === "spotify") {
      return (
        <div
          className="user-avatar spotify"
          style={{
            background: "linear-gradient(135deg, #1db954 0%, #1ed760 100%)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "2rem",
          }}
        >
          <FaMusic />
        </div>
      );
    }

    // Avatar avec icône personnalisée
    if (Icon) {
      return (
        <div
          className="user-avatar custom-icon"
          style={{
            background: "linear-gradient(135deg, #9147ff 0%, #772ce8 100%)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "2rem",
          }}
        >
          <Icon />
        </div>
      );
    }

    return null;
  };

  return (
    <div className="user-card-header">
      {renderAvatar()}
      <div className="user-info">
        <h3 className="user-name">
          {user?.display_name || user?.id || "Utilisateur"}
        </h3>
        <span className={`user-platform ${platform.toLowerCase()}`}>
          {platform}
        </span>
      </div>
    </div>
  );
}

